import SlidePanelT from './SlidePanel.vue'

export const SlidePanel = SlidePanelT
